var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from "react";
import styled from "styled-components";
import * as ReactIcons from "@react-icons/all-files";
var StyledPopoverMenuItem = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    position: relative;\n    grid-gap: 1rem;\n    padding: .5rem 2rem .5rem 2rem;\n    border: 1px solid ".concat(theme.borderContent(), ";\n    list-style: none;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n\n    &:hover {\n      background-color: ").concat(theme.bgContent2(), ";\n      box-shadow: ").concat(theme.boxShadowInset, ";\n    }\n  ");
});
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  left: .5rem;\n  display: flex;\n"], ["\n  position: absolute;\n  left: .5rem;\n  display: flex;\n"])));
var ItemText = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n"], ["\n"])));
export var PopoverMenuItem = function (_a) {
    var text = _a.text, icon = _a.icon, onClick = _a.onClick;
    var Icon = useMemo(function () {
        if (icon && ReactIcons[icon]) {
            return ReactIcons[icon];
        }
        return undefined;
    }, [icon]);
    return (React.createElement(StyledPopoverMenuItem, { onClick: onClick },
        Icon !== undefined && React.createElement(IconWrapper, null,
            React.createElement(Icon, { size: "1rem" })),
        React.createElement(ItemText, null, text)));
};
var templateObject_1, templateObject_2, templateObject_3;
